import React, { ReactNode } from 'react';
import ReactDOM from 'react-dom';
import cn from 'class-names';

import { SVGIcon } from '@uikit/old/Icon/Icon';
import useHotkeys from '@hooks/useHotkeys';

import './BaseModal.scss';

export type BaseModalType = {
  onClose?: (props?: any) => any;
  isOpen: boolean;
  style?: React.CSSProperties;
  classNames?: {
    closeButton?: string;
    modal?: string;
  };
  iconColor?: string;
  closeButton?: boolean;
  closeOnBackgroundClick?: boolean;
  fitWidthContent?: boolean;
  scrollable?: boolean; // it can cut dropdown
  /** data-testid on the modal root; the close button gets `${testId}-close` */
  testId?: string;
};

const BaseModal = ({
  children,
  isOpen,
  onClose,
  style,
  classNames,
  iconColor,
  closeButton = true,
  closeOnBackgroundClick = true,
  fitWidthContent = false,
  scrollable = true,
  testId,
}: BaseModalType & { children: ReactNode }) => {
  useHotkeys({
    Escape: () => onClose(),
  });

  if (!isOpen) {
    return null;
  }

  function onBackgroundClick() {
    if (closeOnBackgroundClick && !!onClose) {
      onClose();
    }
  }

  return ReactDOM.createPortal(
    <div className="modal-overlay" onClick={onBackgroundClick} tabIndex={0} role="button">
      <div
        className={cn('modal', {
          [classNames?.modal]: !!classNames?.modal,
          fitWidthContent,
          scrollable,
        })}
        style={style}
        onClick={(event) => event.stopPropagation()}
        data-testid={testId}
      >
        {closeButton && (
          <span
            className={cn('modal__cross-btn', {
              [classNames?.closeButton]: !!classNames?.closeButton,
            })}
            onClick={onClose}
            tabIndex={0}
            role="button"
            data-testid={testId ? `${testId}-close` : undefined}
          >
            <SVGIcon icon="crossBlack" color={iconColor || '#000000'} />
          </span>
        )}
        {children}
      </div>
    </div>,
    document.body
  );
};

export default React.memo<BaseModalType & { children: ReactNode }>(BaseModal);
